/* ALFA · "Completá tu compra"
   Busca complementos del producto (Search & Discovery) y, si no hay, productos de
   las categorías complementarias del mapa del tema. Arma filas con foto, precio
   y un botón para sumarlo al carrito sin salir de la página. */
(() => {
  const fmt = (cents) => {
    const n = Math.round(Number(cents) || 0) / 100;
    return "$" + n.toLocaleString("es-AR", { minimumFractionDigits: Number.isInteger(n) ? 0 : 2, maximumFractionDigits: 2 });
  };
  const cache = new Map();
  const getJSON = (url) => {
    if (!cache.has(url)) cache.set(url, fetch(url, { credentials: "same-origin" }).then((r) => (r.ok ? r.text() : "[]")).then((t) => { try { return JSON.parse(t); } catch { return []; } }).catch(() => []));
    return cache.get(url);
  };
  const desdeRecos = (p) => ({
    id: p.id, title: p.title, url: p.url, type: p.type,
    price: p.price, compare_at_price: p.compare_at_price || 0,
    image: p.featured_image ? (p.featured_image.startsWith("//") ? "https:" + p.featured_image : p.featured_image) : null,
    variant_id: (p.variants.find((v) => v.available) || p.variants[0])?.id,
    variants: p.variants.length, available: p.available,
  });

  class ComplementosLista extends HTMLElement {
    async connectedCallback() {
      if (this.cargado) return;
      this.cargado = true;
      const id = this.dataset.productId;
      if (!id) return;
      const excluir = new Set((this.dataset.excluir || "").split(",").map((x) => Number(x.trim())).filter(Boolean));
      excluir.add(Number(id));
      const limite = 3;
      let items = [];

      try {
        const r = await getJSON(`${window.Shopify?.routes?.root || "/"}recommendations/products.json?product_id=${id}&limit=6&intent=complementary`);
        items = (r.products || []).filter((p) => p.available).map(desdeRecos);
      } catch {}

      const destinos = (this.dataset.destinos || "").split(",").map((s) => s.trim()).filter(Boolean);
      for (const tipo of destinos) {
        if (items.length >= limite * 2) break;
        const lista = await getJSON(`/collections/types?q=${encodeURIComponent(tipo)}&view=complementos`);
        if (Array.isArray(lista)) items.push(...lista);
      }

      const vistos = new Set();
      items = items.filter((p) => {
        if (!p || !p.variant_id || excluir.has(Number(p.id)) || vistos.has(p.id)) return false;
        vistos.add(p.id);
        return true;
      }).slice(0, limite);
      if (!items.length) return;

      const ul = this.querySelector("[data-complementos-lista]");
      const pct = Number(this.dataset.transfer || 0);
      for (const p of items) {
        const li = document.createElement("li");
        li.className = "complemento";
        const off = p.compare_at_price > p.price ? Math.round((1 - p.price / p.compare_at_price) * 100) : 0;
        const cash = pct > 0 ? Math.round((p.price * (100 - pct)) / 100 / 10000) * 10000 : 0;
        li.innerHTML = `
          <a class="complemento__img" href="${p.url}" tabindex="-1" aria-hidden="true">${p.image ? `<img src="${p.image}" alt="" loading="lazy" width="72" height="72">` : ""}</a>
          <div class="complemento__body">
            <a class="complemento__title" href="${p.url}"></a>
            <span class="complemento__price"><strong class="t-num">${fmt(p.price)}</strong>${off ? `<s class="t-num">${fmt(p.compare_at_price)}</s><span class="badge badge--off">${off}% OFF</span>` : ""}</span>
            ${cash ? `<span class="complemento__cash">${fmt(cash)} con transferencia</span>` : ""}
          </div>
          ${p.variants > 1
            ? `<a class="btn btn--secondary btn--sm complemento__btn" href="${p.url}">Ver</a>`
            : `<add-to-cart data-variant-id="${p.variant_id}" data-quantity="1"><button class="btn btn--secondary btn--sm complemento__btn" type="button" data-track="agregar_complemento" data-track-ubicacion="${this.dataset.ubicacion || "ficha"}"><span data-label>+ Sumar</span></button></add-to-cart>`}`;
        li.querySelector(".complemento__title").textContent = p.title;
        ul.append(li);
      }
      this.hidden = false;
    }
  }
  if (!customElements.get("complementos-lista")) customElements.define("complementos-lista", ComplementosLista);
})();
